[
  {
    "id": "farming",
    "name": "Farming",
    "description": "Gained by harvesting crops and caring for animals.",
    "toolBonus": "Each level grants +1 hoe and watering can proficiency",
    "image": "images/skills/Farming.png",
    "levels": [
      {
        "level": 1,
        "xpRequired": 100,
        "totalXp": 100,
        "recipes": {
          "crafting": ["Scarecrow", "Basic Fertilizer"],
          "cooking": [],
          "additional": []
        }
      },
      {
        "level": 2,
        "xpRequired": 280,
        "totalXp": 380,
        "recipes": {
          "crafting": ["Mayonnaise Machine", "Stone Fence", "Sprinkler"],
          "cooking": [],
          "additional": []
        }
      },
      {
        "level": 3,
        "xpRequired": 390,
        "totalXp": 770,
        "recipes": {
          "crafting": ["Bee House", "Speed-Gro"],
          "cooking": ["Farmer's Lunch"],
          "additional": []
        }
      },
      {
        "level": 4,
        "xpRequired": 530,
        "totalXp": 1300,
        "recipes": {
          "crafting": ["Preserves Jar", "Basic Retaining Soil", "Iron Fence"],
          "cooking": [],
          "additional": []
        }
      },
      {
        "level": 5,
        "xpRequired": 850,
        "totalXp": 2150,
        "recipes": {
          "crafting": [],
          "cooking": [],
          "additional": []
        }
      },
      {
        "level": 6,
        "xpRequired": 1150,
        "totalXp": 3300,
        "recipes": {
          "crafting": ["Cheese Press", "Hardwood Fence", "Quality Sprinkler"],
          "cooking": [],
          "additional": []
        }
      },
      {
        "level": 7,
        "xpRequired": 1500,
        "totalXp": 4800,
        "recipes": {
          "crafting": ["Loom", "Quality Retaining Soil"],
          "cooking": [],
          "additional": []
        }
      },
      {
        "level": 8,
        "xpRequired": 2100,
        "totalXp": 6900,
        "recipes": {
          "crafting": ["Oil Maker", "Keg", "Deluxe Speed-Gro"],
          "cooking": [],
          "additional": []
        }
      },
      {
        "level": 9,
        "xpRequired": 3100,
        "totalXp": 10000,
        "recipes": {
          "crafting": ["Seed Maker", "Iridium Sprinkler", "Quality Fertilizer"],
          "cooking": [],
          "additional": []
        }
      },
      {
        "level": 10,
        "xpRequired": 5000,
        "totalXp": 15000,
        "recipes": { "crafting": [], "cooking": [], "additional": [] }
      }
    ],
    "mastery": {
      "unlocks": [
        {
          "name": "Iridium Scythe",
          "description": "Can harvest any crops and is excellent at gathering hay"
        },
        {
          "name": "Statue of Blessings",
          "description": "Recipe unlocked — provides a unique blessing daily"
        },
        {
          "name": "Golden Animal Crackers",
          "description": "Permanently doubles farm animal produce (except pigs)"
        }
      ]
    }
  },
  {
    "id": "mining",
    "name": "Mining",
    "description": "Increased by breaking rocks.",
    "toolBonus": "Each level adds +1 to pickaxe proficiency",
    "image": "images/skills/Mining.png",
    "levels": [
      {
        "level": 1,
        "xpRequired": 100,
        "totalXp": 100,
        "recipes": { "crafting": ["Cherry Bomb"], "cooking": [], "additional": [] }
      },
      {
        "level": 2,
        "xpRequired": 280,
        "totalXp": 380,
        "recipes": { "crafting": ["Staircase"], "cooking": [], "additional": [] }
      },
      {
        "level": 3,
        "xpRequired": 390,
        "totalXp": 770,
        "recipes": {
          "crafting": [],
          "cooking": ["Miner's Treat"],
          "additional": []
        }
      },
      {
        "level": 4,
        "xpRequired": 530,
        "totalXp": 1300,
        "recipes": {
          "crafting": ["Glowstone Ring", "Transmute (Fe)"],
          "cooking": [],
          "additional": []
        }
      },
      {
        "level": 5,
        "xpRequired": 850,
        "totalXp": 2150,
        "recipes": { "crafting": [], "cooking": [], "additional": [] }
      },
      {
        "level": 6,
        "xpRequired": 1150,
        "totalXp": 3300,
        "recipes": { "crafting": ["Bomb"], "cooking": [], "additional": [] }
      },
      {
        "level": 7,
        "xpRequired": 1500,
        "totalXp": 4800,
        "recipes": { "crafting": ["Transmute (Au)"], "cooking": [], "additional": [] }
      },
      {
        "level": 8,
        "xpRequired": 2100,
        "totalXp": 6900,
        "recipes": { "crafting": ["Mega Bomb"], "cooking": [], "additional": [] }
      },
      {
        "level": 9,
        "xpRequired": 3100,
        "totalXp": 10000,
        "recipes": { "crafting": ["Crystalarium"], "cooking": [], "additional": [] }
      },
      {
        "level": 10,
        "xpRequired": 5000,
        "totalXp": 15000,
        "recipes": { "crafting": [], "cooking": [], "additional": [] }
      }
    ],
    "mastery": {
      "unlocks": [
        {
          "name": "Statue of The Dwarf King",
          "description": "Recipe unlocked — choose from two mining powers daily"
        },
        {
          "name": "Heavy Furnace",
          "description": "Recipe unlocked — more efficient smelting (25 ore + 3 coal per batch)"
        },
        { "name": "Doubled Gem Yield", "description": "Gem-bearing rocks now grant twice the gems" }
      ]
    }
  },
  {
    "id": "foraging",
    "name": "Foraging",
    "description": "Increased by gathering forage items and chopping trees with an axe.",
    "toolBonus": "Each level adds +1 axe proficiency",
    "image": "images/skills/Foraging.png",
    "levels": [
      {
        "level": 1,
        "xpRequired": 100,
        "totalXp": 100,
        "recipes": {
          "crafting": ["Wild Seeds (Sp)", "Field Snack"],
          "cooking": [],
          "additional": ["Trees sometimes drop seeds."]
        }
      },
      {
        "level": 2,
        "xpRequired": 280,
        "totalXp": 380,
        "recipes": { "crafting": ["Charcoal Kiln"], "cooking": [], "additional": [] }
      },
      {
        "level": 3,
        "xpRequired": 390,
        "totalXp": 770,
        "recipes": { "crafting": ["Cookout Kit"], "cooking": ["Moss Soup"], "additional": [] }
      },
      {
        "level": 4,
        "xpRequired": 530,
        "totalXp": 1300,
        "recipes": {
          "crafting": ["Wild Seeds (Su)", "Tapper", "Mushroom Log"],
          "cooking": [],
          "additional": ["+1 Wild Berry harvesting"]
        }
      },
      {
        "level": 5,
        "xpRequired": 850,
        "totalXp": 2150,
        "recipes": { "crafting": [], "cooking": [], "additional": [] }
      },
      {
        "level": 6,
        "xpRequired": 1150,
        "totalXp": 3300,
        "recipes": {
          "crafting": ["Lightning Rod", "Wild Seeds (Fa)", "Warp Totem: Beach"],
          "cooking": [],
          "additional": []
        }
      },
      {
        "level": 7,
        "xpRequired": 1500,
        "totalXp": 4800,
        "recipes": {
          "crafting": ["Wild Seeds (Wi)", "Warp Totem: Mountains", "Tree Fertilizer"],
          "cooking": [],
          "additional": []
        }
      },
      {
        "level": 8,
        "xpRequired": 2100,
        "totalXp": 6900,
        "recipes": {
          "crafting": ["Warp Totem: Farm", "Tent Kit"],
          "cooking": ["Survival Burger"],
          "additional": ["+1 Wild Berry harvesting"]
        }
      },
      {
        "level": 9,
        "xpRequired": 3100,
        "totalXp": 10000,
        "recipes": {
          "crafting": ["Rain Totem"],
          "cooking": [],
          "additional": []
        }
      },
      {
        "level": 10,
        "xpRequired": 5000,
        "totalXp": 15000,
        "recipes": { "crafting": [], "cooking": [], "additional": [] }
      }
    ],
    "mastery": {
      "unlocks": [
        { "name": "Mystic Tree Seed", "description": "Recipe unlocked — grows a special tree" },
        {
          "name": "Treasure Totem",
          "description": "Recipe unlocked — summons a ring of treasure spots"
        },
        {
          "name": "Golden Mystery Box",
          "description": "Superior mystery boxes added to the loot table"
        }
      ]
    }
  },
  {
    "id": "fishing",
    "name": "Fishing",
    "description": "Increased by catching fish and using crab pots.",
    "toolBonus": "Each level grants +1 fishing rod proficiency, increases minimum fish size and bobber bar height, and decreases max time before fish bite",
    "image": "images/skills/Fishing.png",
    "levels": [
      {
        "level": 1,
        "xpRequired": 100,
        "totalXp": 100,
        "recipes": {
          "crafting": [],
          "cooking": [],
          "additional": ["Casting distance increased by one tile"]
        }
      },
      {
        "level": 2,
        "xpRequired": 280,
        "totalXp": 380,
        "recipes": {
          "crafting": ["Bait"],
          "cooking": [],
          "additional": ["Fiberglass Rod & Bait unlocked in Willy's Fish Shop"]
        }
      },
      {
        "level": 3,
        "xpRequired": 390,
        "totalXp": 770,
        "recipes": {
          "crafting": ["Crab Pot"],
          "cooking": ["Dish O' The Sea"],
          "additional": ["Crab Pot unlocked in Willy's Fish Shop"]
        }
      },
      {
        "level": 4,
        "xpRequired": 530,
        "totalXp": 1300,
        "recipes": {
          "crafting": ["Deluxe Bait", "Worm Bin", "Recycling Machine"],
          "cooking": [],
          "additional": [
            "Deluxe Bait unlocked in Willy's Fish Shop",
            "Casting distance increased by one tile"
          ]
        }
      },
      {
        "level": 5,
        "xpRequired": 850,
        "totalXp": 2150,
        "recipes": { "crafting": [], "cooking": [], "additional": [] }
      },
      {
        "level": 6,
        "xpRequired": 1150,
        "totalXp": 3300,
        "recipes": {
          "crafting": ["Bait Maker", "Spinner", "Trap Bobber", "Sonar Bobber"],
          "cooking": [],
          "additional": [
            "Iridium Rod, Sonar Bobber, Lead Bobber, Spinner, Trap Bobber unlocked in Willy's Fish Shop"
          ]
        }
      },
      {
        "level": 7,
        "xpRequired": 1500,
        "totalXp": 4800,
        "recipes": {
          "crafting": ["Cork Bobber", "Treasure Hunter"],
          "cooking": [],
          "additional": ["Cork Bobber & Treasure Hunter unlocked in Willy's Fish Shop"]
        }
      },
      {
        "level": 8,
        "xpRequired": 2100,
        "totalXp": 6900,
        "recipes": {
          "crafting": ["Deluxe Worm Bin", "Barbed Hook", "Dressed Spinner"],
          "cooking": [],
          "additional": [
            "Barbed Hook & Dressed Spinner unlocked in Willy's Fish Shop",
            "Casting distance increased by one tile"
          ]
        }
      },
      {
        "level": 9,
        "xpRequired": 3100,
        "totalXp": 10000,
        "recipes": {
          "crafting": ["Magnet"],
          "cooking": ["Seafoam Pudding"],
          "additional": ["Magnet unlocked in Willy's Fish Shop"]
        }
      },
      {
        "level": 10,
        "xpRequired": 5000,
        "totalXp": 15000,
        "recipes": { "crafting": [], "cooking": [], "additional": [] }
      }
    ],
    "mastery": {
      "unlocks": [
        {
          "name": "Advanced Iridium Rod",
          "description": "Accepts up to two bobbers simultaneously"
        },
        {
          "name": "Challenge Bait",
          "description": "Recipe unlocked — perfect catch yields triple fish, but reduced catch per escape"
        },
        {
          "name": "Golden Fishing Treasure Chest",
          "description": "Superior fishing treasure chests added to the loot table"
        }
      ]
    }
  },
  {
    "id": "combat",
    "name": "Combat",
    "description": "Increased by fighting monsters. Some levels increase total HP.",
    "toolBonus": "Some levels increase max HP",
    "image": "images/skills/Combat.png",
    "levels": [
      {
        "level": 1,
        "xpRequired": 100,
        "totalXp": 100,
        "recipes": { "crafting": ["Sturdy Ring", "Bug Steak"], "cooking": [], "additional": [] }
      },
      {
        "level": 2,
        "xpRequired": 280,
        "totalXp": 380,
        "recipes": { "crafting": ["Life Elixir"], "cooking": [], "additional": [] }
      },
      {
        "level": 3,
        "xpRequired": 390,
        "totalXp": 770,
        "recipes": { "crafting": [], "cooking": ["Roots Platter"], "additional": [] }
      },
      {
        "level": 4,
        "xpRequired": 530,
        "totalXp": 1300,
        "recipes": { "crafting": ["Warrior Ring"], "cooking": [], "additional": [] }
      },
      {
        "level": 5,
        "xpRequired": 850,
        "totalXp": 2150,
        "recipes": { "crafting": [], "cooking": [], "additional": [] }
      },
      {
        "level": 6,
        "xpRequired": 1150,
        "totalXp": 3300,
        "recipes": {
          "crafting": ["Slime Egg-Press", "Oil of Garlic"],
          "cooking": [],
          "additional": []
        }
      },
      {
        "level": 7,
        "xpRequired": 1500,
        "totalXp": 4800,
        "recipes": { "crafting": ["Ring of Yoba", "Thorns Ring"], "cooking": [], "additional": [] }
      },
      {
        "level": 8,
        "xpRequired": 2100,
        "totalXp": 6900,
        "recipes": {
          "crafting": ["Slime Incubator", "Explosive Ammo"],
          "cooking": [],
          "additional": []
        }
      },
      {
        "level": 9,
        "xpRequired": 3100,
        "totalXp": 10000,
        "recipes": {
          "crafting": ["Iridium Band"],
          "cooking": ["Squid Ink Ravioli"],
          "additional": []
        }
      },
      {
        "level": 10,
        "xpRequired": 5000,
        "totalXp": 15000,
        "recipes": { "crafting": [], "cooking": [], "additional": [] }
      }
    ],
    "mastery": {
      "unlocks": [
        {
          "name": "Anvil",
          "description": "Recipe unlocked — re-forge trinkets with randomized stats (costs 3 iridium bars)"
        },
        {
          "name": "Mini-Forge",
          "description": "Recipe unlocked — home furnace access without visiting the blacksmith"
        },
        {
          "name": "Trinket Slot",
          "description": "New equipment slot unlocked — trinkets grant special combat powers"
        }
      ]
    }
  }
]
